import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const TOKEN_KEY = "anypaku.admin.token";

export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => {
  localStorage.setItem(TOKEN_KEY, t);
  window.dispatchEvent(new CustomEvent("anypaku-auth-changed"));
};
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  window.dispatchEvent(new CustomEvent("anypaku-auth-changed"));
};

const client = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000, // 30s — covers slow cold-starts on prod
});

client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const api = {
  login: (email, password) =>
    client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  changePassword: (currentPassword, newPassword) =>
    client
      .post("/auth/change-password", { currentPassword, newPassword })
      .then((r) => r.data),
  getConfig: () => client.get("/config").then((r) => r.data),
  putConfig: (config) => client.put("/config", config).then((r) => r.data),
  distance: (fromAddress, toAddress) =>
    client
      .post("/distance", { fromAddress, toAddress })
      .then((r) => r.data),
  autocomplete: (q) =>
    client
      .get("/geocode/autocomplete", { params: { q } })
      .then((r) => r.data),
  getTexts: () => client.get("/texts").then((r) => r.data),
  putTexts: (texts) => client.put("/texts", texts).then((r) => r.data),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client
      .post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => r.data);
  },
};

/** Resolve an image URL: absolute, frontend-served, or backend-served. */
export const imageUrl = (url) => {
  if (!url) return "";
  if (/^https?:/.test(url)) return url;
  if (url.startsWith("/api/")) return `${API_URL}${url}`;
  return url;
};

export const formatApiError = (err) => {
  // Network failure (mobile data drop, server cold-start exceeded timeout, etc.)
  if (err?.code === "ECONNABORTED") {
    return "La connexion a expiré. Vérifie ton réseau et réessaie.";
  }
  if (err?.message === "Network Error" || !err?.response) {
    return "Pas de connexion au serveur. Vérifie ta connexion internet et réessaie.";
  }
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return err?.message || "Erreur inconnue";
};
